import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import DpiDetails from "./DpDetails";
import DpiCharges from "./DpCharges";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
export default combineReducers({
    dpiDetails: createNamedWrapperReducer(DpiDetails, ERevampReportReducers.DPINTEREST_DETAILS),
    dpiCharges: createNamedWrapperReducer(DpiCharges, ERevampReportReducers.DPCHARGES),
});
